/**
 * Formatting shared by the billing summary page (migration 0053). The email
 * builds the same text in api/send-billing-summaries.js.
 */

/** 135 → "2 h 15 min"; 120 → "2 h"; 45 → "45 min". */
export const formatMinutes = (minutes) => {
  const total = Math.round(Number(minutes ?? 0));
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours && rest) return `${hours} h ${rest} min`;
  if (hours) return `${hours} h`;
  return `${rest} min`;
};

/** ["2026-09-02", "2026-09-09"] → "02/09, 09/09". */
export const shortDates = (dates) => (dates ?? [])
  .map((day) => `${day.slice(8, 10)}/${day.slice(5, 7)}`)
  .join(', ');
